// extracted by mini-css-extract-plugin
export default {"title":"TitleComponent_title__g+sks"};